export const isRenderMoreHooksError = (errMessage) => /Rendered more hooks than during the previous render/.test(errMessage) ||
    /Rendered fewer hooks than expected/.test(errMessage);
